
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSubCategory2Dialog extends Serenity.EntityDialog<CsSubCategory2Row, any> {
        protected getFormKey() { return CsSubCategory2Form.formKey; }
        protected getIdProperty() { return CsSubCategory2Row.idProperty; }
        protected getLocalTextPrefix() { return CsSubCategory2Row.localTextPrefix; }
        protected getNameProperty() { return CsSubCategory2Row.nameProperty; }
        protected getService() { return CsSubCategory2Service.baseUrl; }
        protected getDeletePermission() { return CsSubCategory2Row.deletePermission; }
        protected getInsertPermission() { return CsSubCategory2Row.insertPermission; }
        protected getUpdatePermission() { return CsSubCategory2Row.updatePermission; }

        protected form = new CsSubCategory2Form(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var SkuSub2 = Q.tryFirst(Product.CsSkuRow.getLookup().items, x => x.SubCat2Code == this.entity.SubCat2Code);
            if(SkuSub2 != null){
                this.deleteButton.toggleClass('disabled', true);
                
            }
        }
       

    }
}